export default __webpack_public_path__ + "static/media/icon_aiPlatform.4f7b5035.svg";